import gql from 'graphql-tag';

export const MessageThreadFragment = gql`
  fragment MessagesMessageThreadParticipant on User {
    company {
      id
      name
    }
    firstName
    email
    id
    image {
      src
    }
    lastName
    userRole
  }

  fragment MessagesMessageThread on MessageThread {
    createdAt
    id
    isRead
    participants {
      nodes {
        ...MessagesMessageThreadParticipant
      }
    }
    messages {
      nodes {
        content
        id
        updatedAt
      }
    }
    updatedAt
  }
`;

export const MessageThreadsSuccessFragment = gql`
  fragment MessageThreadsSuccess on MessageThreads {
    pagination {
      currentPage
      perPage
      total
      totalPages
    }
    nodes {
      ...MessagesMessageThread
    }
  }
`;

export const MessageThreadsErrorFragment = gql`
  fragment MessageThreadsError on GenericError {
    kind
    message
  }
`;

export const GET_MESSAGE_THREADS_QUERY = gql`
  query MessagesMessageThreads($participantIds: [String]) {
    messageThreads: messageThreads(participantIds: $participantIds) {
      ...MessageThreadsSuccess
      ...MessageThreadsError
    }
  }

  ${MessageThreadsSuccessFragment}
  ${MessageThreadsErrorFragment}
  ${MessageThreadFragment}
`;
